import { render, staticRenderFns } from "./HearingNotificationitem.vue?vue&type=template&id=19bb7934"
import script from "./HearingNotificationitem.vue?vue&type=script&lang=js"
export * from "./HearingNotificationitem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports